export default {
	SET_TEMPLATES(state, payload) {
		state.templates = payload
	}
}
